<template>

	<transition-group
		name="alert"
		tag="div"
		enter-active-class="animate__animated animate__fadeIn animate__faster"
		leave-to-class="animate__animated animate__fadeOut animate__faster"
	>
		<div key="1" class="featherlight" v-if="shouldShow==true" style="display: block;" v-on:click.self="toggleQuoteForm()">
			<div class="featherlight-content">
				<button class="featherlight-close-icon featherlight-close" aria-label="Close" v-on:click.self="toggleQuoteForm()">✕</button>
				<section class="popup_content featherlight-inner section" v-if="success == false">
					<div class="constraint">
						<h2>Get a quote</h2>
						<div class="form_style" style="align-items: center;">
							<template v-if="errors != [] && errors != null && Object.keys(errors).length > 0">
								<template v-if="errors.store_type || errors.store_id || errors.basket || errors.generic">
									<p class="error"><i class="fas fa-2x fa-exclamation-circle"></i> <span>There was a problem with the form submission. Please reload the page and try again.</span></p>
								</template>
								<template v-else>
									<p class="error"><i class="fas fa-2x fa-exclamation-circle"></i> <span>There was a problem with the form submission. Please check the errors below and try again.</span></p>
								</template>
							</template>

							<p class="half">
								<label for="first_name" class="required">First Name</label>
								<input type="text" id="first_name" name="first_name" placeholder="Enter your first name" v-model="first_name" :class="{ error: errors.first_name }">
								<span v-if="errors.first_name" class="validation-error">{{ errors.first_name[0] }}</span>
							</p>

							<p class="half">
								<label for="last_name" class="required">Last Name</label>
								<input type="text" id="last_name" name="last_name" placeholder="Enter your last name" v-model="last_name" :class="{ error: errors.last_name }">
								<span v-if="errors.last_name" class="validation-error">{{ errors.last_name[0] }}</span>
							</p>

							<p class="half">
								<label for="email_address" class="required">Email Address</label>
								<input type="text" id="email_address" name="email_address" placeholder="Enter your email address" v-model="email_address" :class="{ error: errors.email_address }">
								<span v-if="errors.email_address" class="validation-error">{{ errors.email_address[0] }}</span>
							</p>

							<p class="half">
								<label for="contact_number" class="required">Contact Number</label>
								<input type="text" id="contact_number" name="contact_number" placeholder="Enter your contact number" v-model="contact_number" :class="{ error: errors.contact_number }">
								<span v-if="errors.contact_number" class="validation-error">{{ errors.contact_number[0] }}</span>
							</p>

							<p class="half">
								<label for="size_of_group" class="required">Size of group</label>
								<select id="size_of_group" name="size_of_group" class="styled_select" required v-model="size_of_group" :class="{ error: errors.size_of_group }">
									<option value="" disabled selected>How many people are in your group?</option>
									<option v-for="sz in 40" :key="sz">{{ sz }}</option>
								</select>
								<span v-if="errors.size_of_group" class="validation-error">{{ errors.size_of_group[0] }}</span>
							</p>

							<p class="half">
								<label for="arrival_date" class="required">Arrival date</label>
								<input type="date" :min="min_date" id="arrival_date" name="arrival_date" placeholder="When you you want to arrive?" v-model="arrival_date" :class="{ error: errors.arrival_date }">
								<span v-if="errors.arrival_date" class="validation-error">{{ errors.arrival_date[0] }}</span>
							</p>

							<p class="half">
								<label for="number_of_nights" class="required">Number of nights?</label>
								<select id="number_of_nights" name="number_of_nights" class="styled_select" required v-model="number_of_nights" :class="{ error: errors.number_of_nights }">
									<option value="" disabled selected>How many nights would you like to stay?</option>
									<option>0</option>
									<option v-for="n in 5" :key="n">{{ n }}</option>
								</select>
								<span v-if="errors.number_of_nights" class="validation-error">{{ errors.number_of_nights[0] }}</span>
							</p>

							<p class="half">
								<label for="budget_per_person">Budget per person</label>
								<input type="text" id="budget_per_person" name="budget_per_person" placeholder="Enter your budget per person" v-model="budget_per_person" :class="{ error: errors.budget_per_person }">
								<span v-if="errors.budget_per_person" class="validation-error">{{ errors.budget_per_person[0] }}</span>
							</p>

							<p class="half">
								<label for="readiness">Status</label>
								<select id="readiness" name="readiness" class="styled_select" required v-model="readiness" :class="{ error: errors.readiness }">
									<option value="" disabled selected>How soon do you want to book?</option>
									<option value="Ready to Book ASAP">Ready to Book ASAP</option>
									<option value="Looking to Book Soon">Looking to Book Soon</option>
									<option value="Gathering Ideas">Gathering Ideas</option>
									<option value="Shopping Around">Shopping Around</option>
								</select>
								<span v-if="errors.readiness" class="validation-error">{{ errors.readiness[0] }}</span>
							</p>

							<p class="full styled_checkboxes" v-if="!user_details">
								<input type="checkbox" id="newsletter_consent" name="newsletter_consent" v-model="newsletter_consent" :class="{ error: errors.newsletter_consent }">
								<label for="newsletter_consent">I would like to receive marketing emails about special offers, travel tips and updates from {{ site_name }}.</label>
								<span v-if="errors.newsletter_consent" class="validation-error">{{ errors.newsletter_consent[0] }}</span>
							</p>

							<p class="full info_note" v-if="user_details">
								<small><i class="fas fa-info-circle"></i> Your marketing email preferences can be managed in your <a :href="account_settings_url" target="_blank">account settings</a>.</small>
							</p>

							<p class="half" v-if="recaptcha.enabled==true">
								<vue-recaptcha
									ref="googleRecaptcha"
									:sitekey="recaptcha.key"
									@verify="recaptchaVerified"
									@expired="recaptchaExpired"
								></vue-recaptcha>
								<span v-if="errors.googleRecaptcha" class="validation-error">{{ errors.googleRecaptcha[0] }}</span>
							</p>

							<p class="half" style="margin-left: auto;">
								<span v-show="submit_disabled" :style="'text-align:center; margin:5px auto; color:' + this.accent">
									<i  class="fas fa-spinner fa-fw fa-2x fa-spin"></i><br/>
									<span>Loading...</span>
								</span>
								<button v-show="submit_disabled == false" type="submit" class="button solid arrow wide medium" v-on:click="submitForm()" :style="'--accent:' + this.accent" :disabled="submit_disabled">Request Quote</button>
							</p>
						</div>
					</div>
				</section>
				<section class="quote_form_thanks featherlight-inner section" v-else>
					<div class="constraint">
						<h2><i class="fal fa-glass-cheers fa-2x"></i> Thank you for your enquiry</h2>
						<p>We have received your details and will be in touch soon.</p>
					</div>
				</section>
			</div>
		</div>
	 </transition-group>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { VueRecaptcha } from 'vue-recaptcha';
import VueCompositionAPI from '@vue/composition-api';
export default {

	components: { VueRecaptcha },

	props: [
		'accent',
		'store_id',
		'store_type',
		'user_details',
		'account_settings_url'
	],

	data: () => {
		return {
			csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
			first_name: '',
			last_name: '',
			email_address: '',
			contact_number: '',
			size_of_group: '',
			arrival_date: '',
			budget_per_person: '',
			number_of_nights: '',
			readiness: '',
			newsletter_consent: false,
			errors: [],
			min_date: new Date().toISOString().slice(0, 10),
			recaptcha: {
				enabled: ((process.env.MIX_RECAPTCHA_ENABLED == 'true') ? true : false),
				key: process.env.MIX_GOOGLE_RECAPTCHA_SITEKEY,
				robot: false,
			},
			shouldShow: false,
			success: false,
			submit_disabled: false,
			site_name: process.env.MIX_APP_NAME || 'our company',
		}
	},

	computed: {
		items () {
			return this.$store.getters.getItem(this.store_id, this.store_type);
		},
	},

	watch: {
	},

	created() {
	},

	mounted() {

		if (this.user_details != null && Object.keys(this.user_details).length > 0) {
			this.first_name = this.user_details.first_name;
			this.last_name = this.user_details.last_name;
			this.email_address = this.user_details.email;
			this.contact_number = this.user_details.telephone;
			this.newsletter_consent = this.user_details.marketing_consent || false;
		}
	},

	methods: {

		submitForm: function() {
			this.submit_disabled = true;
			if(this.recaptcha.enabled == false || (this.recaptcha.enabled == true && this.recaptcha.robot == true)){
				var self = this;
				axios.post('/ajax/postQuoteForm', {
					store_id: this.store_id,
					store_type: this.store_type,
					first_name: this.first_name,
					last_name: this.last_name,
					email_address: this.email_address,
					contact_number: this.contact_number,
					size_of_group: this.size_of_group,
					arrival_date: this.arrival_date,
					number_of_nights: this.number_of_nights,
					budget_per_person: this.budget_per_person,
					readiness: this.readiness,
					newsletter_consent: this.user_details ? this.user_details.marketing_consent : this.newsletter_consent,
					basket: this.items,
				})
				.then(response => {

					if(response.data=='success') {
						this.success = true;
						this.submit_disabled = false;

						// window.google_trackConversion({
						// 	google_conversion_id: 968391849,
						// 	google_conversion_language: "en",
						// 	google_conversion_format: "3",
						// 	google_conversion_color: "ffffff",
						// 	google_conversion_label: "j-ySCJCKhmAQqfnhzQM",
						// 	google_remarketing_only: false
						// });

						gtag('event', 'conversion', {
							'send_to': 'AW-968391849/j-ySCJCKhmAQqfnhzQM',
							'value': 1.00
						});

					}else{
						this.errors = response.data['errors'];
						this.recaptchaExpired();
						this.submit_disabled = false;
						// needs to scroll to top
					}
				})
				.catch(error => {
					if(error.response.status == 422) {
						var errors = error.response.data['errors'];
						this.errors = errors;
						this.recaptchaExpired();
						this.submit_disabled = false;
						// needs to scroll to top
					}
				});
			}else{
				this.errors.googleRecaptcha = [];
				this.errors.googleRecaptcha.push('Complete the reCAPTCHA to submit the form');
				this.recaptchaExpired();
				this.$forceUpdate();
				this.submit_disabled = false;
			}
		},

		recaptchaVerified: function(response) {
			if (response) {
				this.recaptcha.robot = true;
			}
		},

		recaptchaExpired: function() {
			if(this.recaptcha.enabled){
				this.$refs.googleRecaptcha.reset();
			}
			this.recaptcha.robot = false;
		},

		wrap: function(el, wrapper) {
			el.parentNode.insertBefore(wrapper, el);
			wrapper.appendChild(el);
		},

		toggleQuoteForm: function(){
			if(this.shouldShow==true) {
				this.shouldShow = false;
				this.success = false;
				this.first_name = '';
				this.last_name = '';
				this.email_address = '';
				this.contact_number = '';
				this.size_of_group = '';
				this.arrival_date = '';
				this.number_of_nights = '',
				this.budget_per_person = '';
				this.readiness = '';
				this.errors = [];
			}else{
				this.shouldShow = true;
				this.$nextTick(function() {
					this.initStyledSelect();
				});
			}
		},

		initStyledSelect: function(){
			// do a pure javascript version of the select wrapper code
			for(var i=0; i<document.querySelectorAll(".form_style select, .styled_select").length; i++) {
				var elem = document.querySelectorAll(".form_style select, .styled_select")[i];
				if(!elem.parentElement.classList.contains('select_wrapper')) {
					var wrapper = document.createElement('div');
					wrapper.classList.add("select_wrapper");
					this.wrap(elem, wrapper);
				}
			}
		}

	}
};
</script>
